const ErrorQueryNames = {
    ErrorTitle: 'error_title',
    ErrorDescription: 'error_description',
    LoginAvailable: 'login_available',
};

export default ErrorQueryNames;
